import { render, staticRenderFns } from "./TopBlock.vue?vue&type=template&id=1665aea4&scoped=true"
import script from "./TopBlock.vue?vue&type=script&lang=js"
export * from "./TopBlock.vue?vue&type=script&lang=js"
import style0 from "./TopBlock.vue?vue&type=style&index=0&id=1665aea4&prod&lang=scss&scoped=true"
import style1 from "./TopBlock.vue?vue&type=style&index=1&id=1665aea4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1665aea4",
  null
  
)

export default component.exports